import { Phone } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface Props {
  onClick: () => void
  /** Le composeur est ouvert. */
  actif?: boolean
  darkMode: boolean
  /** Liste repliée : un peu plus grand, seul dans sa colonne. */
  grand?: boolean
}

/**
 * Ouvre le composeur « Appeler ou écrire ». Une icône de téléphone, teintée
 * comme l'action d'appel, et non un clavier : sur ordinateur, on y vient pour
 * appeler quelqu'un, pas pour taper sur un pavé.
 */
export function BoutonAppeler({ onClick, actif = false, darkMode, grand = false }: Props) {
  const { t } = useTranslation()
  const titre = t('phone.composer.title', 'Appeler ou écrire')

  return (
    <button
      type="button"
      onClick={onClick}
      title={titre}
      aria-label={titre}
      aria-pressed={actif}
      className={cn(
        'flex flex-shrink-0 items-center justify-center rounded-md transition-colors',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-green-500',
        grand ? 'h-9 w-9' : 'h-7 w-7',
        actif
          ? 'bg-green-500 text-white'
          : darkMode
            ? 'bg-green-500/15 text-green-400 hover:bg-green-500/25'
            : 'bg-green-50 text-green-700 hover:bg-green-100',
      )}
    >
      <Phone className={grand ? 'h-4 w-4' : 'h-3.5 w-3.5'} />
    </button>
  )
}
